/* ============================================================
   Inline SVG icon registry

   No icon font, no sprite fetch — icons must render offline and on
   first paint. Audit A-20/A-21: paths are re-authored on a consistent
   24×24 grid with a 1.6 stroke, and sizing no longer depends on a
   fragile string replace against hardcoded width/height attributes.
   ============================================================ */

const PATHS = {
  check: '<path d="M4.5 12.5 9.5 17.5 19.5 7"/>',
  right: '<path d="M4 12h15"/><path d="m13 6 6 6-6 6"/>',
  left: '<path d="M20 12H5"/><path d="m11 6-6 6 6 6"/>',
  down: '<path d="M12 5v14"/><path d="m6 13 6 6 6-6"/>',
  close: '<path d="M6 6l12 12"/><path d="M18 6 6 18"/>',
  menu: '<path d="M4 7h16"/><path d="M4 12h16"/><path d="M4 17h16"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><path d="M12 7.75h.01"/>',
  alert:
    '<path d="M12 4.5 2.8 20h18.4L12 4.5Z"/><path d="M12 10v4"/><path d="M12 17.25h.01"/>',
  clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3 2"/>',
  calendar:
    '<rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17"/><path d="M8 3v4"/><path d="M16 3v4"/>',
  document:
    '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8.5L13.5 3Z"/><path d="M13.5 3v5.5H19"/><path d="M8.5 13h7"/><path d="M8.5 16.5h4.5"/>',
  data: '<path d="M4 19.5V11"/><path d="M9.75 19.5V5.5"/><path d="M15.5 19.5v-6"/><path d="M21 19.5V8"/>',
  chart:
    '<path d="M4 4v15.5a.5.5 0 0 0 .5.5H20"/><path d="m7.5 14.5 3.5-4 3 2.5 4.5-5.5"/>',
  truck:
    '<path d="M3 6.5h10.5v9.5H3z"/><path d="M13.5 10h3.6l2.9 3.2V16h-6.5z"/><circle cx="7" cy="18" r="1.9"/><circle cx="17" cy="18" r="1.9"/>',
  train:
    '<rect x="5" y="4" width="14" height="12.5" rx="2.5"/><path d="M5 10.5h14"/><path d="m7.5 20 2-3.5"/><path d="m16.5 20-2-3.5"/><path d="M9.5 13.5h.01"/><path d="M14.5 13.5h.01"/>',
  ship: '<path d="M4 12.5 12 9l8 3.5"/><path d="M6 12V7.5h12V12"/><path d="M12 4v5"/><path d="M3.5 16.5c1.8 0 1.8 2 3.6 2s1.8-2 3.6-2 1.8 2 3.6 2 1.8-2 3.6-2"/>',
  warehouse:
    '<path d="M3.5 20V9.5L12 5l8.5 4.5V20"/><path d="M8.5 20v-6h7v6"/><path d="M3.5 20h17"/>',
  pin: '<path d="M12 21s6.5-5.6 6.5-10.5a6.5 6.5 0 1 0-13 0C5.5 15.4 12 21 12 21Z"/><circle cx="12" cy="10.5" r="2.4"/>',
  group:
    '<circle cx="9" cy="8.5" r="3.2"/><path d="M3 19.5a6 6 0 0 1 12 0"/><path d="M16.5 6.2a3.2 3.2 0 0 1 0 6.1"/><path d="M17.5 14.2a6 6 0 0 1 3.5 5.3"/>',
  setting:
    '<circle cx="12" cy="12" r="3"/><path d="M12 3.5v2.2M12 18.3v2.2M20.5 12h-2.2M5.7 12H3.5M18 6l-1.6 1.6M7.6 16.4 6 18M18 18l-1.6-1.6M7.6 7.6 6 6"/>',
  shield: '<path d="M12 3.5 5 6v6c0 4.3 3 7.3 7 8.5 4-1.2 7-4.2 7-8.5V6l-7-2.5Z"/>',
  coins:
    '<ellipse cx="12" cy="7" rx="7" ry="3"/><path d="M5 7v5c0 1.7 3.1 3 7 3s7-1.3 7-3V7"/><path d="M5 12v5c0 1.7 3.1 3 7 3s7-1.3 7-3v-5"/>',
  leaf: '<path d="M20 4c0 9-5.4 13.5-11 13.5A5 5 0 0 1 4 12.5C4 7.5 10.5 4 20 4Z"/><path d="M4 20c2-5 6-8 11-10"/>',
  download: '<path d="M12 4v11"/><path d="m7 10.5 5 5 5-5"/><path d="M4.5 19.5h15"/>',
  globe:
    '<circle cx="12" cy="12" r="9"/><path d="M3.2 9.5h17.6"/><path d="M3.2 14.5h17.6"/><path d="M12 3a15 15 0 0 1 0 18"/><path d="M12 3a15 15 0 0 0 0 18"/>',
  lock: '<rect x="5" y="10.5" width="14" height="10" rx="2.5"/><path d="M8.25 10.5V7.75a3.75 3.75 0 0 1 7.5 0v2.75"/>',
  refresh:
    '<path d="M20 11.5a8 8 0 1 0-.9 5"/><path d="M20 4.5v5h-5"/>',
  link:
    '<path d="M10.5 13.5a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1.7 1.7"/><path d="M13.5 10.5a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.7-1.7"/>'
};

/**
 * Render an icon as an SVG string.
 * @param {string} name  key from the registry
 * @param {number} size  pixel size (square)
 * @param {object} opts  { strokeWidth, title }
 */
export function icon(name, size = 20, opts = {}) {
  const body = PATHS[name];
  if (!body) {
    console.warn(`Icon "${name}" not found`);
    return '';
  }

  const { strokeWidth = 1.6, title = '' } = opts;
  const label = title
    ? `role="img" aria-label="${title.replace(/"/g, '&quot;')}"`
    : 'aria-hidden="true"';

  return (
    `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" ` +
    `stroke="currentColor" stroke-width="${strokeWidth}" stroke-linecap="round" ` +
    `stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" ${label}>${body}</svg>`
  );
}

export function iconExists(name) {
  return Object.prototype.hasOwnProperty.call(PATHS, name);
}

export function iconNames() {
  return Object.keys(PATHS);
}
